import React, { MutableRefObject, useRef, useContext } from 'react';
import { FlexColumn } from '../layouts';
import { Button, Dropdown } from 'semantic-ui-react';
import '../localization/config';
import { useTranslation } from 'react-i18next';
import { AuthenticationContext } from '../providers/AuthenticationProvider';
import { useNavigate } from 'react-router-dom';

export interface IUserProfile {}

const UserProfile = (_props: IUserProfile) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { onLogout, isAuthenticated, email, userManager } = useContext(
    AuthenticationContext
  );

  const handleChange = (_e: any, data: any) => {
    console.log(data.value);
    switch (data.value) {
      case 'manageUsers':
        navigate('/users');
        break;
      case 'logOut':
        onLogout();
        break;
      case 'logIn':
        break;
    }
  };

  const options = isAuthenticated()
    ? userManager
      ? [
          { value: 'logOut', text: `${t('userProfile.logOut')} ${email}` },
          { value: 'manageUsers', text: t('userProfile.manageUsers') },
        ]
      : [{ value: 'logOut', text: `${t('userProfile.logOut')} ${email}` }]
    : [{ value: 'logIn', text: t('userProfile.logIn') }];

  const dropdownRef = useRef();
  return (
    <FlexColumn>
      <Button.Group>
        <Button
          circular
          icon="user"
          onClick={(e) =>
            // @ts-ignore
            dropdownRef.current && dropdownRef.current.handleClick(e)
          }
        />
        <Dropdown
          direction="left"
          floating
          onChange={handleChange}
          options={options}
          ref={dropdownRef as MutableRefObject<any>}
        />
      </Button.Group>
    </FlexColumn>
  );
};

export default UserProfile;
